import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ProcessFlowCheckItem,
  ProcessFlowHistory,
  ProcessFlowStepItemNote,
} from '../models/process-flow.model';

@Injectable({
  providedIn: 'root',
})
export class ProcessFlowService {
  private apiServerUrl = environment.loganConfig.url;
  constructor(private http: HttpClient) {}

  public getProcessFlow(): Observable<any> {
    return this.http.get<any>(`${this.apiServerUrl}/api/v1/processFlow`);
  }
  public updateCheckItem(
    processFlowCheckItem: ProcessFlowCheckItem
  ): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/v1/updateCheckItem`,
      processFlowCheckItem
    );
  }
  public updateStepIsDone(
    processFlowCheckItem: ProcessFlowCheckItem
  ): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/v1/updateStepIsDone`,
      processFlowCheckItem
    );
  }

  public addProcessFlowStepItemNote(
    itemNote: ProcessFlowStepItemNote
  ): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/v1/addProcessFlowStepItemNote`,
      itemNote
    );
  }
  public getHistoryProcessFlow(
    processFlowId: number
  ): Observable<ProcessFlowHistory[]> {
    return this.http.get<ProcessFlowHistory[]>(
      `${this.apiServerUrl}/api/v1/historyProcess/${processFlowId}`
    );
  }
  public getHistoryProcessFlowStep(
    processFlowId: number,
    processFlowStepId: number
  ): Observable<any> {
    return this.http.get<any>(
      `${this.apiServerUrl}/api/v1/historyProcessStep/${processFlowId}/${processFlowStepId}`
    );
  }
}
